

//const PROMOCION_API_URL = "https://134.209.222.33:8443";
//const PROMOCION_API_URL_NORMAL = "http://134.209.222.33:8083";

//const PROMOCION_API_URL = "https://134.209.222.33:8443/HCBack";
const PROMOCION_API_URL = "http://134.209.222.33:8080/HCBack";
const PROMOCION_API_URL_NORMAL = "http://134.209.222.33:8080/HCBack";


//const PROMOCION_API_URL = "http://localhost:8083";
//const PROMOCION_API_URL = "https://localhost:8443";

//const PROMOCION_API_URL = "http://192.168.1.11:8083";

//const PROMOCION_API_URL = 'http://192.168.236.242:8083'
//const API_URL_EXT = 'http://192.168.236.242:9003'

class ConectionDataService {
  getURL() {
    return PROMOCION_API_URL;
  }
  getURLNORMAL() {
    return PROMOCION_API_URL_NORMAL;
  }
  getURLAPIEXT() {
    return API_URL_EXT;
  }
}

export default new ConectionDataService();
